/* global __webpack_public_path__:writable */
__webpack_public_path__ = window.__assetBase || '/v2/';
import "@stimulus/polyfills"
import { Application } from "stimulus";
import { registerTo } from "./controllers";
const application = Application.start();
registerTo(application).then(() =>{
  console.log('loaded');
});